import { createContext } from 'react';

const loadContext = createContext();

export default loadContext;